import React, { useState, useEffect } from "react";
import {
  AppstoreOutlined,
  ExceptionOutlined,
  ApiOutlined,
  UserOutlined,
  AliwangwangOutlined,
  BugOutlined,
  ScheduleOutlined,
  FormOutlined,
  PlayCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import { isMobile } from "react-device-detect";
import type { MenuProps } from "antd";

const { Sider } = Layout;
function MenuAdmin() {
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const permissions = useAppSelector((state) => state.account.user.permissions);
  const [menuItems, setMenuItems] = useState<MenuProps["items"]>([]);

  useEffect(() => {
    if (permissions?.length) {
      // const viewDashboard = permissions.find(
      //   (item) => item.apiPath === "/api/v1/dashboard" && item.method === "GET"
      // );
      const viewPost = permissions.find(
        (item) => item.apiPath === "/api/v1/posts" && item.method === "GET"
      );

      const viewUser = permissions.find(
        (item) => item.apiPath === "/api/v1/users" && item.method === "GET"
      );

      const viewCategory = permissions.find(
        (item) => item.apiPath === "/api/v1/category" && item.method === "GET"
      );
      const viewPodcast = permissions.find(
        (item) => item.apiPath === "/api/v1/podcast" && item.method === "GET"
      );

      const viewRole = permissions.find(
        (item) => item.apiPath === "/api/v1/roles" && item.method === "GET"
      );

      const viewPermission = permissions.find(
        (item) =>
          item.apiPath === "/api/v1/permissions" && item.method === "GET"
      );
      const viewEmailFollow = permissions.find(
        (item) =>
          item.apiPath === "/api/v1/email-follow" && item.method === "GET"
      );
      const viewUpload = permissions.find(
        (item) =>
          item.apiPath === "/api/v1/upload" && item.method === "GET"
      );

      const full = [
        // ...(viewDashboard
        //   ? [
        //       {
        //         label: <Link to="/admin">Dashboard</Link>,
        //         key: "/admin",
        //         icon: <AppstoreOutlined />,
        //       },
        //     ]
        //   : []),
        {
          label: <Link to="/admin">Dashboard</Link>,
          key: "/admin",
          icon: <AppstoreOutlined />,
        },

        ...(viewUser
          ? [
              {
                label: <Link to="/admin/user">User</Link>,
                key: "/admin/user",
                icon: <UserOutlined />,
              },
            ]
          : []),

        ...(viewPost
          ? [
              {
                label: <Link to="/admin/post">Post</Link>,
                key: "/admin/post",
                icon: <FormOutlined />,
              },
            ]
          : []),
        ...(viewPodcast
          ? [
              {
                label: <Link to="/admin/podcast">Podcast</Link>,
                key: "/admin/podcast",
                icon: <PlayCircleOutlined />,
              },
            ]
          : []),
        ...(viewCategory
          ? [
              {
                label: <Link to="/admin/category">Category</Link>,
                key: "/admin/category",
                icon: <AliwangwangOutlined />,
              },
            ]
          : []),
        ...(viewRole
          ? [
              {
                label: <Link to="/admin/role">Role</Link>,
                key: "/admin/role",
                icon: <ExceptionOutlined />,
              },
            ]
          : []),
        ...(viewPermission
          ? [
              {
                label: <Link to="/admin/permission">Permission</Link>,
                key: "/admin/permission",
                icon: <ApiOutlined />,
              },
            ]
          : []),
        ...(viewEmailFollow
          ? [
              {
                label: <Link to="/admin/email-follow">Email follow</Link>,
                key: "/admin/email-follow",
                icon: <ScheduleOutlined />,
              },
            ]
          : []),
        ...(viewUpload
          ? [
              {
                label: <Link to="/admin/upload">Upload</Link>,
                key: "/admin/upload",
                icon: <UploadOutlined />,
              },
            ]
          : []),
      ];
      setMenuItems(full);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions.length]);
  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location]);

  return (
    <>
      {!isMobile ? (
        <Sider
          theme="light"
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}>
          <div style={{ height: 32, margin: 16, textAlign: "center" }}>
            <BugOutlined /> ADMIN
          </div>
          <Menu
            selectedKeys={[activeMenu]}
            mode="inline"
            items={menuItems}
            onClick={(e) => setActiveMenu(e.key)}
          />
        </Sider>
      ) : (
        <Menu
          selectedKeys={[activeMenu]}
          items={menuItems}
          onClick={(e) => setActiveMenu(e.key)}
          mode="horizontal"
        />
      )}
    </>
  );
}

export default MenuAdmin;
